// src/pages/Perfil.js

import React, { useState, useEffect } from 'react';
import apiClient from '../services/api';
import { toast } from 'react-toastify';
import Card from '../components/Card';
import Button from '../components/Button';
import { useNavigate } from 'react-router-dom';

const AVATARES_DISPONIBLES = ['🚀', '🦄', '🦊', '🤖', '👾', '⭐', '🦖', '⚽', '🎨', '🎸'];

function Perfil() {
  const [nombre, setNombre] = useState(''); // <-- Nuevo estado para el nombre
  const [avatarSeleccionado, setAvatarSeleccionado] = useState('');
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPerfil = async () => {
      try {
        const response = await apiClient.get('/perfil/');
        setNombre(response.data.first_name || ''); // Rellenamos el nombre
        setAvatarSeleccionado(response.data.avatar || AVATARES_DISPONIBLES[0]);
      } catch (error) {
        toast.error("No se pudo cargar tu perfil.");
      } finally {
        setLoading(false);
      }
    };
    fetchPerfil();
  }, []);

  const handleGuardar = async () => {
    try {
      // Enviamos tanto el avatar como el nombre
      await apiClient.put('/perfil/', { avatar: avatarSeleccionado, first_name: nombre });
      toast.success("¡Perfil guardado con éxito!");
      alert("Para ver tus cambios en todas partes, por favor cierra y vuelve a iniciar sesión.");
      navigate('/dashboard-nino');
    } catch (error) {
      toast.error("No se pudo guardar tu perfil.");
    }
  };

  if (loading) return <div className="p-8 text-center text-xl">Cargando tu perfil...</div>;

  return (
    <div className="p-8 max-w-2xl mx-auto">
      <Card>
        <h1 className="text-3xl font-bold text-principal mb-6 text-center">Mi Perfil Mágico</h1>
        
        {/* --- NUEVO CAMPO PARA EL NOMBRE --- */}
        <div className="mb-8">
            <label className="block text-gray-700 font-bold mb-2 text-lg">Tu Nombre</label>
            <input
                type="text"
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
                placeholder="Escribe aquí tu nombre"
                className="w-full px-4 py-3 border-2 rounded-lg text-xl focus:outline-none focus:ring-2 focus:ring-principal"
            />
        </div>

        <label className="block text-gray-700 font-bold mb-2 text-lg">Elige tu Avatar</label>
        <div className="flex justify-center mb-8">
            <div className="text-8xl bg-fondo p-6 rounded-full">
                {avatarSeleccionado}
            </div>
        </div>

        <div className="grid grid-cols-5 gap-4 mb-8">
          {AVATARES_DISPONIBLES.map(avatar => (
            <button
              key={avatar}
              onClick={() => setAvatarSeleccionado(avatar)}
              className={`text-5xl p-4 rounded-2xl transition-all duration-200 ${avatarSeleccionado === avatar ? 'bg-principal ring-4 ring-acento scale-110' : 'bg-fondo hover:bg-principal hover:bg-opacity-20'}`}
            >
              {avatar}
            </button>
          ))}
        </div>

        <div className="flex justify-center">
            <Button variant="accent" onClick={handleGuardar}>
                Guardar mis Cambios
            </Button>
        </div>
      </Card>
    </div>
  );
}

export default Perfil;